


























































import { Component, Vue, Watch } from "vue-property-decorator";
import { AppConstants, Models, apiService, Interfaces } from "@/core/Export";
import store from "@/store";
@Component({
  components: {}
})
export default class RedRouteContinuePage extends Vue {
  requestNo: string = "";
  constructor() {
    super();
  }

  created () { }

  onContinueRequestForResident (e) {
    e.preventDefault();
    let continueForm = this.$refs.continueForm as any;
    continueForm.validate().then(success => {
      if (success) {
        this.appEnv.isBusy = true;
        apiService
          .post(`Request/VerifyResidentRequestNoPerYear/`, {
            requestId: this.appEnv.requestParams.requestId,
            requestNo: this.requestNo
          })
          .then(res => {
            let response = res as Interfaces.ICallResult;
            if (response && response.isSuccess) {
              store.commit("updateTRequestModel", response.result);
              this.appEnv.canViewRequestRouteRedPage = true;
              this.$router.push({
                name: AppConstants.Routes.RedRoute,
                query: { isContinue: "true" }
              });
            } else {
              this.appEnv.showErrorDialog(response.msgs.errors);
            }
            this.appEnv.isBusy = false;
          })
          .catch(err => {
            this.appEnv.isBusy = false;
          });
      }
    });
  }

  onCreateNewResidentRequest () {
    this.appEnv.canViewRequestRouteRedPage = true;
    this.$router.push({
      name: AppConstants.Routes.RedRoute
    });
  }

  get appEnv () {
    return store.getters.appEnv;
  }
}
